import { Controller } from "@hotwired/stimulus"

// Surface A corner editor (Phase F3 — dense list).
//
// The corner list is now a flat list of dense single-line rows, each with an
// always-visible name <input> inside its own PATCH form. There is no accordion
// anymore, so this controller is reduced to the one piece that has to be
// focus-safe: committing a rename.
//
// Why focus-safety matters: a rename PATCH returns the `card_stream` Turbo
// Stream that REPLACES the whole #track_corners_card (so the header counters
// stay truthful). If the input committed on every keystroke, that swap would
// rip the focused field out mid-type. So we commit only on `change` (which
// fires after the field loses focus) and turn Enter into a blur — by the time
// the request goes out, focus has already left the field and the swap is safe.
export default class extends Controller {
  // The card carries the track's fresh corners_geometry_json. The corner-curation
  // parent holds this card as an outlet and, on every card_stream replace, reads
  // this value to re-sync the hero map + timeline in place (the map element is
  // never swapped). It's a passive data carrier here — corner-editor itself only
  // needs the rename commit logic below.
  static values = { corners: Array }

  // Commit the inline name form. Bound to `change` on the input — fires once the
  // field has lost focus, so the subsequent card replace can't steal focus.
  submitName(event) {
    event.target.closest("form")?.requestSubmit()
  }

  // Enter commits via blur: blurring fires `change`, which submits. This keeps a
  // single commit path and guarantees focus is gone before the Turbo swap.
  blurOnEnter(event) {
    event.preventDefault()
    event.target.blur()
  }
}
